import React from 'react'
import Button from '@components/Button'
import Card from '@components/Card'
import Header from '@components/Header'
import ScrollContainer from '@components/ScrollContainer'
import StepDescription from '@components/StepDescription'
import { colors } from '@lib/colors'
import { i18n } from '@lib/i18n'
import MainLayout from '@layouts/MainLayout'
import { Image, Linking, StyleSheet, Text, TouchableWithoutFeedback, View } from 'react-native'

const COPY = i18n.en.WORK_ORDERS.CREATE.THANK_YOU

export default function ({ onNew, context }: DefaultStepProps) {
  const createNewWorkOrder = onNew

  return (
    <MainLayout hideBackButton>
      <ScrollContainer>
        <View style={ styles.contentWrapper }>
          <View>
            <Header>{ COPY.HEADER }</Header>
            <StepDescription>{ COPY.DESCRIPTION }</StepDescription>
            <Card style={ styles.card }>
              <Image
                source={ require('@assets/Done.png') }
                resizeMode='contain'
                style={ styles.finishedImage }/>
            </Card>

            <EmailNotice email={context.email} />
          </View>

          <Button
            label={ COPY.NEXT_STEP }
            buttonStyles={ styles.button }
            onPress={ createNewWorkOrder }
          />
        </View>
      </ScrollContainer>
    </MainLayout>
  )
}

interface EmailNoticeProps {
  email: Maybe<string>
}

const EmailNotice = ({ email }: EmailNoticeProps) => {
  return (
    <View style={ styles.noticeTextWrapper }>
      <Text style={ styles.noticeText }>
        <Text>{COPY.EMAIL_NOTIFICATION_START}</Text>
        <Text style={ styles.tenantEmail }>{email}</Text>
        <Text>{COPY.EMAIL_NOTIFICATION_MIDDLE}</Text>
        <TouchableWithoutFeedback
          onPress={() => Linking.openURL('mailto: workorders@spackle.co')}
        >
          <Text style={styles.spackleEmail}>workorders@spackle.co</Text>
        </TouchableWithoutFeedback>
        <Text>{COPY.EMAIL_NOTIFICATION_END}</Text>
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: colors.green[500],
  },
  card: {
    marginBottom: 20,
    marginTop: 20,
    padding: 40,
    aspectRatio: 1.4,
  },
  contentWrapper: {
    flex: 1,
    justifyContent: 'space-between',
  },
  finishedImage: {
    width: '100%',
    height: '100%',
  },
  noticeTextWrapper: {
    marginBottom: 40,
  },
  noticeText: {
    color: colors.gray[700],
    lineHeight: 20,
    textAlign: 'center',
  },
  tenantEmail: {
    fontStyle: 'italic',
  },
  spackleEmail: {
    color: colors.blue[300],
    fontWeight: 'bold',
  },
  updateProfile: {
    color: colors.blue[300],
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
})
